import Button from '../Button';
import styles from './CompletionButton.module.scss';
import { showCheckmarkInCircleIcon, showRightArrowIcon, showRightArrowWhiteIcon } from '../../core/core';

interface Props {
  buttonText: string;
  handleClick: () => void;
}

interface ButtonTypes {
  colorProp: string;
  icon: React.ReactNode;
}

const buttonType: { [x: string]: ButtonTypes } = {
  Complete: {
    colorProp: 'completed',
    icon: showCheckmarkInCircleIcon(),
  },
  Explore: {
    colorProp: 'grey',
    icon: showRightArrowIcon(),
  },
  Resume: {
    colorProp: '',
    icon: showRightArrowWhiteIcon(),
  },
  Soon: {
    colorProp: 'greyDisabled',
    icon: '',
  },
  Watch: {
    colorProp: 'grey',
    icon: showRightArrowIcon(),
  },
  View: {
    colorProp: 'grey',
    icon: showRightArrowIcon(),
  },
};

const getButton = (textKey: keyof { [x: string]: ButtonTypes }) => {
  return buttonType[textKey];
};

const CompletionButton = ({ buttonText, handleClick }: Props): JSX.Element => {
  let propsToPass: { [x: string]: boolean } | null = {};
  propsToPass[getButton(buttonText).colorProp] = true;
  if (buttonText === 'Resume') propsToPass = null;

  return (
    <div className={styles.middleSchoolButton}>
      <Button onClick={handleClick} {...propsToPass}>
        <span className={styles.buttonText}>{buttonText}</span>
        <span className={styles.icon}>{getButton(buttonText).icon}</span>
      </Button>
    </div>
  );
};

export default CompletionButton;
